module.exports = __webpack_public_path__ + "img/shenuo.6957f85f.png";